var map = {
	"./wse-workbooks-disabled-level-1.png": 4744,
	"./wse-workbooks-disabled-level-10.png": 7510,
	"./wse-workbooks-disabled-level-11.png": 1697,
	"./wse-workbooks-disabled-level-12.png": 7045,
	"./wse-workbooks-disabled-level-13.png": 1197,
	"./wse-workbooks-disabled-level-14.png": 6625,
	"./wse-workbooks-disabled-level-15.png": 8150,
	"./wse-workbooks-disabled-level-16.png": 1123,
	"./wse-workbooks-disabled-level-17.png": 2202,
	"./wse-workbooks-disabled-level-18.png": 1417,
	"./wse-workbooks-disabled-level-19.png": 5309,
	"./wse-workbooks-disabled-level-2.png": 9444,
	"./wse-workbooks-disabled-level-20.png": 4914,
	"./wse-workbooks-disabled-level-3.png": 4472,
	"./wse-workbooks-disabled-level-4.png": 3147,
	"./wse-workbooks-disabled-level-5.png": 9764,
	"./wse-workbooks-disabled-level-6.png": 7321,
	"./wse-workbooks-disabled-level-7.png": 6278,
	"./wse-workbooks-disabled-level-8.png": 1531,
	"./wse-workbooks-disabled-level-9.png": 4081,
	"./wse-workbooks-front-level-1.png": 404,
	"./wse-workbooks-front-level-10.png": 6271,
	"./wse-workbooks-front-level-11.png": 4716,
	"./wse-workbooks-front-level-12.png": 2417,
	"./wse-workbooks-front-level-13.png": 6864,
	"./wse-workbooks-front-level-14.png": 6647,
	"./wse-workbooks-front-level-15.png": 7351,
	"./wse-workbooks-front-level-16.png": 8722,
	"./wse-workbooks-front-level-17.png": 2787,
	"./wse-workbooks-front-level-18.png": 8154,
	"./wse-workbooks-front-level-19.png": 4102,
	"./wse-workbooks-front-level-2.png": 7937,
	"./wse-workbooks-front-level-20.png": 3930,
	"./wse-workbooks-front-level-3.png": 1629,
	"./wse-workbooks-front-level-4.png": 5493,
	"./wse-workbooks-front-level-5.png": 1878,
	"./wse-workbooks-front-level-6.png": 338,
	"./wse-workbooks-front-level-7.png": 3815,
	"./wse-workbooks-front-level-8.png": 9579,
	"./wse-workbooks-front-level-9.png": 7868,
	"./wse-workbooks-level-1.png": 2101,
	"./wse-workbooks-level-10.png": 8933,
	"./wse-workbooks-level-11.png": 7355,
	"./wse-workbooks-level-12.png": 606,
	"./wse-workbooks-level-13.png": 4720,
	"./wse-workbooks-level-14.png": 2913,
	"./wse-workbooks-level-15.png": 3300,
	"./wse-workbooks-level-16.png": 9378,
	"./wse-workbooks-level-17.png": 3265,
	"./wse-workbooks-level-18.png": 5431,
	"./wse-workbooks-level-19.png": 4411,
	"./wse-workbooks-level-2.png": 9533,
	"./wse-workbooks-level-20.png": 5851,
	"./wse-workbooks-level-3.png": 2498,
	"./wse-workbooks-level-4.png": 294,
	"./wse-workbooks-level-5.png": 8320,
	"./wse-workbooks-level-6.png": 2428,
	"./wse-workbooks-level-7.png": 757,
	"./wse-workbooks-level-8.png": 1826,
	"./wse-workbooks-level-9.png": 3559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6120;